"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlCtepParameterSerialization = void 0;
class ChargerControlCtepParameterSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.timestamp_utc = entity.timestamp_utc
            ? entity.timestamp_utc.getTime() * 1000000
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.timestamp_utc = entity.timestamp_utc
            ? new Date(entity.timestamp_utc / 1000000)
            : undefined;
        return copy;
    }
}
exports.ChargerControlCtepParameterSerialization = ChargerControlCtepParameterSerialization;
